module.exports = __webpack_public_path__ + "69785c35.svg";